
export class UtilitiesRegex {

    static get numberElementRegex() {
        return new RegExp('^-?([0-9]*)$', 'gm');
    }
}
